import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

/**
 * Scroll to top button that appears when user scrolls down
 */
export const ScrollToTop: React.FC = () => {
  const [showScrollTop, setShowScrollTop] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300); // Show scroll-to-top after 300px
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <motion.button
      className="fixed bottom-20 right-6 z-40 p-3 bg-gradient-to-r from-emerald-500 to-cyan-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300"
      initial={{ opacity: 0, scale: 0 }}
      animate={{ 
        opacity: showScrollTop ? 1 : 0, 
        scale: showScrollTop ? 1 : 0 
      }}
      transition={{ duration: 0.3 }}
      onClick={scrollToTop}
      whileHover={{ scale: 1.1 }}
      whileTap={{ scale: 0.9 }}
      style={{ 
        pointerEvents: showScrollTop ? 'auto' : 'none',
      }}
      aria-label="Scroll to top"
    >
      <motion.svg
        className="w-6 h-6"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        animate={{ y: [0, -2, 0] }}
        transition={{ duration: 1.5, repeat: Infinity }}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M5 10l7-7m0 0l7 7m-7-7v18"
        />
      </motion.svg>
    </motion.button>
  );
};
